import { Box } from "@mui/material";
import MainHeader from "./main_header";
import StartHeader from "./start_header";



export default function MainLayout(props) {

    const { children, menus, onOpenChange, activeMenu, isAuth } = props;
    return (
        <Box>
            {isAuth ? <MainHeader menus={menus} onOpenChange={onOpenChange} children={children} activeMenu={activeMenu} /> : <StartHeader children={children} />}
        </Box>
    );
}